import React from "react";
import { withStyles } from "@material-ui/core/styles";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import SalesTodayChart from "../containers/salesTodayChart";
import SalesByKioskTodayChart from "../containers/salesByKioskTodayChart";

const Dashboard = ({ classes, permissions }) => (
  <div className={classes.container}>
    <Card>
      <CardHeader title="AlpiLink Admin" />
      <CardContent>Système de supervision AlpiLink</CardContent>
    </Card>
    {permissions !== "super_admin" && (
      <Card className={classes.chartCard}>
        <SalesTodayChart />
      </Card>
    )}
    {permissions !== "super_admin" && (
      <Card className={classes.chartCard}>
        <SalesByKioskTodayChart />
      </Card>
    )}
  </div>
);

const styles = () => ({
  container: {
    marginTop: 10,
  },
  chartCard: {
    marginTop: 20,
  },
});

export default withStyles(styles)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard.js